import React, { useEffect, useMemo, useState } from "react";
import {
  Card, CardBody, Col, Container, Row,
  Input, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Label
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const durumText = d => d === 1 ? "Kabul Edildi" : d === 2 ? "Reddedildi" : "Bekliyor";
const durumColor = d => d === 1 ? "success" : d === 2 ? "danger" : "warning";

const Tekliflerim = () => {
  document.title = "Tekliflerim | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const userId = authUser?.ID;
  const isAdmin = authUser?.HESAP_TURU === "Admin";
  // ILAN_TEKLIFLERI DELETE artık [Authorize] + sahiplik kontrollü; token yoksa 401.
  const authToken = localStorage.getItem("token") || authUser?.Token;

  const [targetUserId, setTargetUserId] = useState("ALL");
  const [usersList, setUsersList] = useState([]);

  const [offers, setOffers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [dateFilter, setDateFilter] = useState(null);

  const [selectedOffer, setSelectedOffer] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  // Admin ise kullanıcı listesini çek
  useEffect(() => {
    if (isAdmin) {
      fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD,HESAP_TURU&$top=500`)
        .then(r => r.json())
        .then(d => setUsersList(d.value || []))
        .catch(() => {});
    }
  }, [isAdmin]);

  const fetchOffers = async () => {
    if (!userId) return;
    setIsLoading(true);
    try {
      let filterStr = "";
      if (!isAdmin) {
        filterStr = `$filter=KULLANICI_ID eq ${userId}&`;
      } else if (targetUserId !== "ALL") {
        filterStr = `$filter=KULLANICI_ID eq ${targetUserId}&`;
      }

      const resp = await fetch(
        `${BASE_URL}/ILAN_TEKLIFLERI?${filterStr}$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress,CEP_NO),ILANLAR($select=ID,AD,FIYAT,INDIRIMLI_FIYAT,KATEGORI_ID;$expand=KULLANICILAR($select=AD_SOYAD,CEP_NO))&$orderby=ID desc`
      );
      const result = await resp.json();
      if (result?.value) setOffers(result.value);
    } catch {
      toast.error("Teklifler yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchOffers(); }, [userId, targetUserId]);

  const handleOfferStatusUpdate = async (offerId, newDurum) => {
    const durumNo = newDurum === "Kabul Edildi" ? 1 : 2;
    try {
      const resp = await fetch(`${BASE_URL}/ILAN_TEKLIFLERI(${offerId})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ DURUM: durumNo })
      });
      if (!resp.ok) throw new Error();
      setOffers(prev => prev.map(o => o.ID === offerId ? { ...o, DURUM: durumNo } : o));
      if (selectedOffer?.ID === offerId) setSelectedOffer(prev => ({ ...prev, DURUM: durumNo }));
      toast.success(`Teklif ${newDurum} olarak güncellendi.`);
    } catch {
      toast.error("Güncelleme sırasında hata oluştu.");
    }
  };

  const handleDelete = async () => {
    if (!selectedOffer) return;
    try {
      const res = await fetch(`${BASE_URL}/ILAN_TEKLIFLERI(${selectedOffer.ID})`, {
        method: "DELETE",
        headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      });
      if (!res.ok && res.status !== 204) {
        toast.error(
          res.status === 409
            ? "Kabul edilmiş teklif silinemez."
            : res.status === 401 || res.status === 403
              ? "Bu teklifi silme yetkiniz yok."
              : "Teklif silinemedi."
        );
        return;
      }
      setDeleteModalVisible(false);
      setModalVisible(false);
      setSelectedOffer(null);
      fetchOffers();
      toast.success("Teklif silindi.");
    } catch {
      toast.error("Teklif silinemedi.");
    }
  };

  const filteredOffers = useMemo(() => {
    let result = [...offers];
    if (query.trim()) {
      const q = query.toLowerCase();
      result = result.filter(o =>
        o.ID?.toString().includes(q) ||
        o.KULLANICILAR?.AD_SOYAD?.toLowerCase().includes(q) ||
        o.ILANLAR?.AD?.toLowerCase().includes(q) ||
        o.TEKLIF_TUTARI?.toString().includes(q)
      );
    }
    if (statusFilter !== "ALL") {
      result = result.filter(o => durumText(o.DURUM) === statusFilter);
    }
    if (dateFilter) {
      result.sort((a, b) => {
        const dA = new Date(a.OLUSTURMA_TARIHI || 0).getTime();
        const dB = new Date(b.OLUSTURMA_TARIHI || 0).getTime();
        return dateFilter === "NEW" ? dB - dA : dA - dB;
      });
    }
    return result;
  }, [offers, query, statusFilter, dateFilter]);

  const formatDate = (val) => {
    if (!val) return "---";
    return new Date(val).toLocaleDateString("tr-TR");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Hesabım" breadcrumbItem="Tekliflerim" />

          {/* Admin: Kullanıcı filtresi */}
          {isAdmin && (
            <Row className="mb-4">
              <Col md={12} lg={8} xl={6}>
                <Card className="shadow-sm border border-info mb-0">
                  <CardBody className="py-3 px-4">
                    <Label className="fw-bold text-info mb-2 d-flex align-items-center">
                      <i className="mdi mdi-shield-account fs-4 me-2" /> Admin — Kullanıcı Filtresi
                    </Label>
                    <Input
                      type="select"
                      value={targetUserId}
                      onChange={e => setTargetUserId(e.target.value)}
                    >
                      <option value="ALL">Tüm Kullanıcıların Teklifleri</option>
                      {usersList.map(u => (
                        <option key={u.ID} value={u.ID}>
                          {u.AD_SOYAD} ({u.HESAP_TURU || "Bilinmiyor"})
                        </option>
                      ))}
                    </Input>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          <Row>
            {/* Sol: Filtreler */}
            <Col lg="3">
              <Card>
                <CardBody>
                  <h6 className="fw-bold mb-3">Filtrele</h6>

                  <Input
                    type="text"
                    placeholder="İlan adı, kullanıcı, tutar..."
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    className="mb-3"
                  />

                  <div className="border-top pt-3 mb-3">
                    <h6 className="fw-medium mb-2 font-size-13">Teklif Durumu</h6>
                    {["ALL", "Bekliyor", "Kabul Edildi", "Reddedildi"].map(s => (
                      <div className="form-check mb-1" key={s}>
                        <Input
                          type="radio"
                          name="status"
                          id={`s-${s}`}
                          checked={statusFilter === s}
                          onChange={() => setStatusFilter(s)}
                        />
                        <Label className="form-check-label" htmlFor={`s-${s}`}>
                          {s === "ALL" ? "Tümü" : s}
                        </Label>
                      </div>
                    ))}
                  </div>

                  <div className="border-top pt-3 mb-3">
                    <h6 className="fw-medium mb-2 font-size-13">Tarih Sıralaması</h6>
                    <div className="d-flex gap-2">
                      <Button
                        color={dateFilter === "NEW" ? "primary" : "light"}
                        size="sm"
                        onClick={() => setDateFilter(dateFilter === "NEW" ? null : "NEW")}
                      >En Yeni</Button>
                      <Button
                        color={dateFilter === "OLD" ? "primary" : "light"}
                        size="sm"
                        onClick={() => setDateFilter(dateFilter === "OLD" ? null : "OLD")}
                      >En Eski</Button>
                    </div>
                  </div>

                  {(statusFilter !== "ALL" || dateFilter || query) && (
                    <div className="border-top pt-3 text-center">
                      <Button color="danger" outline size="sm" onClick={() => { setStatusFilter("ALL"); setDateFilter(null); setQuery(""); }}>
                        <i className="mdi mdi-close me-1" />Filtreleri Temizle
                      </Button>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>

            {/* Sağ: Teklif Kartları */}
            <Col lg="9">
              {isLoading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                  <p className="text-muted mt-2">Teklifler yükleniyor...</p>
                </div>
              ) : filteredOffers.length === 0 ? (
                <Card className="text-center py-5 border bg-light shadow-none">
                  <CardBody>
                    <i className="mdi mdi-text-box-search-outline display-4 text-muted mb-3 d-block" />
                    <h5 className="fw-bold">Teklif Bulunamadı</h5>
                    <p className="text-muted">Kriterlere uygun teklif yok.</p>
                  </CardBody>
                </Card>
              ) : (
                <Row>
                  {filteredOffers.map(item => (
                    <Col xl={6} key={item.ID}>
                      <Card className="shadow-sm border">
                        <CardBody>
                          {/* Üst: ID + Durum + Tarih */}
                          <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-3">
                            <div>
                              <Badge className="bg-soft-primary text-primary px-2 py-1 me-2 font-size-12">
                                Teklif #{item.ID}
                              </Badge>
                              <Badge color={durumColor(item.DURUM)} className="font-size-12">
                                {durumText(item.DURUM)}
                              </Badge>
                              {isAdmin && item.KULLANICILAR && (
                                <div className="mt-2 font-size-12 text-muted">
                                  <i className="mdi mdi-account me-1" />
                                  {item.KULLANICILAR.AD_SOYAD}
                                </div>
                              )}
                            </div>
                            <small className="text-muted">{formatDate(item.OLUSTURMA_TARIHI)}</small>
                          </div>

                          {/* Ürün bilgisi */}
                          <div className="bg-light p-2 rounded mb-3">
                            <div className="fw-medium text-dark">
                              <i className="bx bx-package me-1 text-primary" />
                              {item.ILANLAR?.AD || `İlan #${item.ILAN_ID}`}
                            </div>
                            {item.ILANLAR?.FIYAT && (
                              <small className="text-muted">
                                İlan fiyatı: {parseFloat(item.ILANLAR.FIYAT).toLocaleString("tr-TR")} ₺
                              </small>
                            )}
                          </div>

                          {/* Teklif tutarı + butonlar */}
                          <div className="d-flex justify-content-between align-items-end">
                            <div>
                              <h4 className="text-success fw-bold mb-0">
                                {parseFloat(item.TEKLIF_TUTARI || 0).toLocaleString("tr-TR")} ₺
                              </h4>
                              <small className="text-muted">Teklif Tutarı</small>
                            </div>
                            <div className="d-flex gap-2">
                              {isAdmin && (
                                <>
                                  <Button color="success" size="sm" outline
                                    disabled={item.DURUM === 1}
                                    onClick={() => handleOfferStatusUpdate(item.ID, "Kabul Edildi")}>
                                    <i className="mdi mdi-check" />
                                  </Button>
                                  <Button color="danger" size="sm" outline
                                    disabled={item.DURUM === 2}
                                    onClick={() => handleOfferStatusUpdate(item.ID, "Reddedildi")}>
                                    <i className="mdi mdi-close" />
                                  </Button>
                                </>
                              )}
                              <Button color="light" size="sm" className="text-primary fw-bold"
                                onClick={() => { setSelectedOffer(item); setModalVisible(true); }}>
                                Detay <i className="mdi mdi-chevron-right" />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </div>

      {/* Detay Modal */}
      <Modal isOpen={modalVisible} toggle={() => setModalVisible(false)} size="lg" centered scrollable>
        <ModalHeader toggle={() => setModalVisible(false)} className="bg-light">
          Teklif Detayı
        </ModalHeader>
        <ModalBody className="p-4">
          {selectedOffer && (
            <>
              {isAdmin && selectedOffer.KULLANICILAR && (
                <div className="mb-4">
                  <h6 className="text-muted fw-bold text-uppercase mb-2 font-size-11">Teklifi Veren</h6>
                  <Card className="shadow-none border border-info bg-soft-info mb-0">
                    <CardBody className="p-3">
                      <Row>
                        <Col sm={6}><i className="mdi mdi-account me-1 text-info" /> {selectedOffer.KULLANICILAR.AD_SOYAD}</Col>
                        <Col sm={6}><i className="mdi mdi-email me-1 text-info" /> {selectedOffer.KULLANICILAR.Mail_Adress}</Col>
                      </Row>
                    </CardBody>
                  </Card>
                </div>
              )}

              <div className="mb-4">
                <h6 className="text-muted fw-bold text-uppercase mb-2 font-size-11">İlan Bilgileri</h6>
                <Card className="shadow-none border bg-light mb-0">
                  <CardBody className="p-3">
                    <Row>
                      <Col sm={4}>
                        <small className="text-muted d-block">İlan Adı</small>
                        <span className="fw-medium">{selectedOffer.ILANLAR?.AD || `#${selectedOffer.ILAN_ID}`}</span>
                      </Col>
                      <Col sm={4}>
                        <small className="text-muted d-block">İlan Fiyatı</small>
                        <span className="fw-medium">
                          {selectedOffer.ILANLAR?.FIYAT
                            ? `${parseFloat(selectedOffer.ILANLAR.FIYAT).toLocaleString("tr-TR")} ₺`
                            : "-"}
                        </span>
                      </Col>
                      <Col sm={4}>
                        <small className="text-muted d-block">İlan Sahibi</small>
                        <span className="fw-medium">{selectedOffer.ILANLAR?.KULLANICILAR?.AD_SOYAD || "-"}</span>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </div>

              <div className="mb-4">
                <h6 className="text-muted fw-bold text-uppercase mb-2 font-size-11">Teklif Bilgileri</h6>
                <Row>
                  <Col sm={4}>
                    <small className="text-muted d-block">Teklif Tarihi</small>
                    <span className="fw-medium">{formatDate(selectedOffer.TEKLIF_TARIHI || selectedOffer.OLUSTURMA_TARIHI)}</span>
                  </Col>
                  <Col sm={4}>
                    <small className="text-muted d-block">Durum</small>
                    <Badge color={durumColor(selectedOffer.DURUM)}>{durumText(selectedOffer.DURUM)}</Badge>
                  </Col>
                  <Col sm={4}>
                    <small className="text-muted d-block">Teklif No</small>
                    <span className="fw-medium">#{selectedOffer.ID}</span>
                  </Col>
                </Row>
              </div>

              <Card className="shadow-none border border-success bg-soft-success mb-0">
                <CardBody className="p-3 d-flex justify-content-between align-items-center">
                  <h5 className="text-success mb-0 fw-bold">TEKLİF TUTARI</h5>
                  <h4 className="text-success mb-0 fw-bold">
                    {parseFloat(selectedOffer.TEKLIF_TUTARI || 0).toLocaleString("tr-TR")} ₺
                  </h4>
                </CardBody>
              </Card>
            </>
          )}
        </ModalBody>
        <ModalFooter className="bg-light">
          <div className="w-100 d-flex justify-content-between">
            {isAdmin ? (
              <div className="d-flex gap-2">
                <Button color="success" disabled={selectedOffer?.DURUM === 1}
                  onClick={() => handleOfferStatusUpdate(selectedOffer.ID, "Kabul Edildi")}>
                  <i className="mdi mdi-check me-1" />Kabul Et
                </Button>
                <Button color="danger" outline disabled={selectedOffer?.DURUM === 2}
                  onClick={() => handleOfferStatusUpdate(selectedOffer.ID, "Reddedildi")}>
                  <i className="mdi mdi-close me-1" />Reddet
                </Button>
              </div>
            ) : (
              <Button color="danger" outline onClick={() => setDeleteModalVisible(true)}>
                <i className="mdi mdi-trash-can-outline me-1" />Teklifi Sil
              </Button>
            )}
            <Button color="secondary" outline onClick={() => setModalVisible(false)}>Kapat</Button>
          </div>
        </ModalFooter>
      </Modal>

      {/* Silme Onay Modal */}
      <Modal isOpen={deleteModalVisible} toggle={() => setDeleteModalVisible(false)} centered size="sm">
        <ModalHeader toggle={() => setDeleteModalVisible(false)}>Teklifi Sil</ModalHeader>
        <ModalBody className="text-center py-4">
          <i className="mdi mdi-trash-can-outline display-4 text-danger mb-3 d-block" />
          <p>Bu teklifi silmek istediğinize emin misiniz?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setDeleteModalVisible(false)}>Vazgeç</Button>
          <Button color="danger" onClick={handleDelete}>Evet, Sil</Button>
        </ModalFooter>
      </Modal>

      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default Tekliflerim;
